import React from "react";
import { components } from "react-select";
export default function SolidControl (props) {
  return <components.Control {...props} className={`w-100 form-control form-control-solid h-auto py-2 px-2`}/>
}
